(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-onver-film]').forEach((card) => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const video = card.querySelector('video');
      const button = card.querySelector('button');
      const label = button.querySelector('[data-label]');
      const start = Number(card.dataset.start);
      const end = Number(card.dataset.end);
      const sync = () => {
        const playing = !video.paused;
        card.classList.toggle('is-playing', playing);
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', playing ? button.dataset.pause : button.dataset.play);
        label.textContent = playing ? button.dataset.pauseShort : button.dataset.playShort;
      };
      const seekStart = () => { if (video.currentTime < start || video.currentTime >= end) video.currentTime = start; };
      video.addEventListener('loadedmetadata', seekStart);
      video.addEventListener('timeupdate', seekStart);
      video.addEventListener('ended', () => { video.currentTime = start; video.pause(); sync(); });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', async () => {
        if (!video.paused) { video.pause(); return; }
        scope.querySelectorAll('[data-onver-film] video').forEach((other) => { if (other !== video) other.pause(); });
        if (!video.getAttribute('src')) { video.src = video.dataset.src; video.load(); }
        if (video.readyState >= 1) seekStart();
        video.muted = true;
        try { await video.play(); card.querySelector('.ov-film-error')?.remove(); }
        catch {
          video.pause();
          if (!card.querySelector('.ov-film-error')) {
            const message = document.createElement('p');
            message.className = 'ov-film-error';
            message.setAttribute('role', 'status');
            message.textContent = button.dataset.error;
            card.querySelector('.ov-film-frame').append(message);
          }
        }
        sync();
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => { if (!entries[0].isIntersecting) video.pause(); }, { threshold: 0.1 });
        observer.observe(card);
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
